import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./contentTitle.html";
import { getBooleanAttr } from '../common/common';
export let ContentTitleLevels = /*#__PURE__*/function (ContentTitleLevels) {
  ContentTitleLevels["One"] = "1";
  ContentTitleLevels["Two"] = "2";
  ContentTitleLevels["Three"] = "3";
  ContentTitleLevels["Four"] = "4";
  ContentTitleLevels["Five"] = "5";
  ContentTitleLevels["Six"] = "6";
  ContentTitleLevels["Seven"] = "7";
  ContentTitleLevels["Eight"] = "8";
  ContentTitleLevels["None"] = "none";
  return ContentTitleLevels;
}({});
class ContentTitle extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = void 0;
    this.level = ContentTitleLevels.Two;
    this.customStyles = void 0;
    this._truncate = true;
    this._isLoading = false;
  }
  set isLoading(value) {
    this._isLoading = getBooleanAttr(value);
  }
  get isLoading() {
    return this._isLoading;
  }
  set truncate(value) {
    this._truncate = getBooleanAttr(value);
  }
  get truncate() {
    return this._truncate;
  }
  get style() {
    return this._truncate ? 'ellipsis' : '';
  }
  set loadingWidth(value) {
    this.template.host.style.setProperty('--ads-loading-width', value);
  }
  get loadingWidth() {
    return this.template.host.style.getPropertyValue('--ads-loading-width');
  }
  get isHeading() {
    return typeof this.level === 'string' || this.level !== ContentTitleLevels.None;
  }
  get titleClass() {
    return this.customStyles ? 'custom' : '';
  }
  get isLevel1() {
    return this.level === ContentTitleLevels.One;
  }
  get isLevel2() {
    return this.level === ContentTitleLevels.Two;
  }
  get isLevel3() {
    return this.level === ContentTitleLevels.Three;
  }
  get isLevel4() {
    return this.level === ContentTitleLevels.Four;
  }
  get isLevel5() {
    return this.level === ContentTitleLevels.Five;
  }
  get isLevel6() {
    return this.level === ContentTitleLevels.Six;
  }
  get isLevel7() {
    return this.level === ContentTitleLevels.Seven;
  }
  get isLevel8() {
    return this.level === ContentTitleLevels.Eight;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ContentTitle, {
  publicProps: {
    title: {
      config: 0
    },
    level: {
      config: 0
    },
    customStyles: {
      config: 0
    },
    isLoading: {
      config: 3
    },
    truncate: {
      config: 3
    },
    loadingWidth: {
      config: 3
    }
  },
  track: {
    _truncate: 1,
    _isLoading: 1
  }
});
const __lwc_component_class_internal = _registerComponent(ContentTitle, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;